interface CustomWindow extends Window {
  dataLayer: any;
}

declare const window: CustomWindow;

export type ISetTrackDataLayer = {
  event: string;
  digitalData: {
    form?: {
      name?: string,
      stepName?: string,
      errorFields?: string[],
    },
    linkPage?: string,
    linkName?: string,
    linkType?: string,
    linkPosition?: string,
  }
}
export const setTrackDataLayer = (data: ISetTrackDataLayer) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    ...data
  });
};

const setDataLink = (link: HTMLAnchorElement) => {
  let position = '';
  if (link.closest('footer')) {
    position = 'footer';
  } else if (link.closest('main')) {
    position = 'body';
  } else if (link.closest('header')) {
    position = 'header';
  }

  const type = link.classList.contains('button') ? 'button' : 'anchor link';

  link.addEventListener('click', () => {
    setTrackDataLayer({
      event: 'linkClick',
      digitalData: {
        linkName: link.innerText,
        linkPage: link.href,
        linkType: type,
        linkPosition: position
      }
    });
  });
}

export const TrackLinks = () => {
  const links = document.querySelectorAll('a');
  links.forEach((link) => {
    setDataLink(link);
  });
};
